module.exports = __webpack_public_path__ + "img/canecacafe.5152f50d.gif";